import request from '../../utils/request';

export default () => request('/config/default-ala-level');
